import { render, staticRenderFns } from "./EngagementProjectSettings.vue?vue&type=template&id=3970efb1&"
import script from "./EngagementProjectSettings.vue?vue&type=script&lang=js&"
export * from "./EngagementProjectSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports